import React, { useState } from "react";
import { StationDTO } from "../types/stationDTO";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";

registerLocale('fi', fi);

type Args = {
  headerText: string;
  station: StationDTO;
  submitted: (station: StationDTO) => void;
  deleted?: (station: StationDTO) => void;
};

const StationForm = ({ headerText, station: initialStation, submitted, deleted }: Args) => {
  const { t, i18n } = useTranslation();
  const [stationState, setStationState] = useState(initialStation);
  const nav = useNavigate();

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    submitted(stationState);
  };

  const onCancel: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    nav(-1);
  }

  const onDelete: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    deleted?.(stationState);
  };

  return (
    <div className="ml-3">
      <h5 className="subtitle text-left mb-2">{headerText}</h5>
      <form>
        {/* <div className="form-group">
          <label htmlFor="id">Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Id"
            value={stationState.id}
            readOnly
          />
        </div>
        <div className="form-group">
          <label htmlFor="orgId">Organisation Id</label>
          <input
            type="text"
            className="form-control"
            placeholder="Organisation Id"
            value={stationState.organisationId}
            readOnly
          />
        </div> */}
        <div className="form-group">
          <label htmlFor="name">{t('common.name')}</label>
          <input
            type="text"
            maxLength={200}
            className="form-control"
            value={stationState.name}
            onChange={(e) =>
              setStationState({ ...stationState, name: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="address">{t('common.address')}</label>
          <input
            type="text"
            maxLength={200}
            className="form-control"
            value={stationState.address}
            onChange={(e) =>
              setStationState({ ...stationState, address: e.target.value })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="municipality">{t('common.municipality')}</label>
          <input
            type="text"
            maxLength={200}
            className="form-control"
            value={stationState.municipality}
            onChange={(e) =>
              setStationState({ ...stationState, municipality: e.target.value })
            }
          />
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validFrom">{t('common.validFrom')}</label>
          <div>
          <DatePicker
              className="form-control"
              dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
              locale={i18n.language === 'fi' ? 'fi' : 'en'}
              selected={stationState.validFrom}
              onChange={(date: Date | null) => date && setStationState({ ...stationState, validFrom: date })}
              showTimeSelect
            />
          </div>
        </div>
        <div className="form-group mt-2">
          <label htmlFor="validTo">{t('common.validTo')}</label>
          <div>
          <DatePicker
            className="form-control"
            dateFormat={i18n.language === 'en' ? 'yyyy-MM-dd hh:mm' : 'dd.MM.yyyy HH:mm'}
            locale={i18n.language === 'fi' ? 'fi' : 'en'}
            selected={stationState.validTo}
            onChange={(date: Date | null) => date && setStationState({ ...stationState, validTo: date })}
            showTimeSelect
          />
          </div>
        </div>
        <button
          className="btn btn-primary mt-3 me-2"
          disabled={!stationState.name || !stationState.address || !stationState.municipality}
          onClick={onSubmit}>
          {t('buttons.save')}
        </button>
        {deleted && (
          <button
            className="btn btn-danger mt-3 me-2"
            onClick={onDelete}>
            {t('buttons.delete')}
          </button>
        )}
        <button
          className="btn btn-danger mt-3"
          onClick={onCancel}>
          {t('buttons.cancel')}
        </button>
      </form>
    </div>
  );
};

export default StationForm;
